import queryString, { StringifyOptions } from 'query-string';

export const ROUTES = {
    homepage: '/',
    news: '/news',
    activity: {
        search: '/activity',
        bulkActions: '/activity/bulk/:action',
        view: '/activity/:id',
        watchlist: '/activity/watchlist',
        clusters: '/activity/cluster',
        create: '/activity/create',
        clone: '/activity/:id/clone',
        createTemplate: '/activity/create-template',
        cloneFromTemplate: '/activity/:id/clone-from-template',
        scheduler: '/activity/scheduler',
        changeRequest: {
            view: '/activity/:id/change-request/:changeRequestId',
        },
    },
    logbook: '/logbook',
    dimr: {
        search: '/dimr',
        view: '/dimr/:id/:version',
        viewLatest: '/dimr/:id',
        create: '/dimr/create',
    },
    wdp: {
        create: '/wdp/create',
        search: '/wdp',
        view: '/wdp/:id/:version',
        viewLatest: '/wdp/:id',
        clone: '/wdp/:id/:version/clone',
    },
    vic: {
        search: '/vic',
        view: '/vic/:id',
        create: '/vic/create',
        clone: '/vic/:id/clone',
    },
    lockout: {
        search: '/lockout',
        view: '/lockout/:id',
        create: '/lockout/create',
        clone: '/lockout/:id/clone',
    },
    firePermit: {
        search: '/firepermit',
        view: '/firepermit/:id',
        create: '/firepermit/create',
        clone: '/firepermit/:id/clone',
    },
    is37: {
        search: '/is37',
        view: '/is37/:id',
        create: '/is37/create',
        clone: '/is37/:id/clone',
    },
    noteDeCoupure: {
        search: '/notedecoupure',
        view: '/notedecoupure/:id',
        create: '/notedecoupure/create',
        clone: '/notedecoupure/:id/clone',
    },
    tasks: '/tasks',
    radiationDoses: '/radiationdoses',
    accessControl: '/accesscontrol',
    locations: '/locations',
    professionalVisits: '/professionalVisits',
    statistics: '/statistics',
    calendar: '/calendar',
    roleAssignments: '/roleAssignments',
    interventionPeriods: '/interventionPeriods',
    fieldVisibilities: '/fieldVisibilities',
    localization: {
        values: '/localization/values',
        frontend: '/localization/frontend',
        backend: '/localization/backend',
    },
    notFound: '/not-found',
} as const;

type DescendantsOf<Obj, T> = Obj extends T ? Obj : DescendantsOf<Obj[keyof Obj], T>;
export type RouteType = DescendantsOf<typeof ROUTES, string>;

export const replaceParams = ({
    path,
    params,
}: {
    path: string;
    params: { [key: string]: string | number | undefined };
}) =>
    Object.keys(params).reduce((acc, key) => {
        const paramRegex = new RegExp(`:${key}`, 'g');
        const value = params[key];
        return value !== undefined ? acc.replace(paramRegex, String(value)) : acc;
    }, path);

const withQueryParams = (
    {
        path,
        queryParams,
    }: {
        path: string;
        queryParams: { [key: string]: string | number | undefined };
    },
    options?: StringifyOptions
) => queryString.stringifyUrl({ url: path, query: queryParams }, options);

export const getRoute = (
    {
        path,
        params = {},
        queryParams = {},
    }: {
        path: string;
        params?: { [key: string]: string | number | undefined };
        queryParams?: { [key: string]: string | number | undefined };
    },
    options?: StringifyOptions
) => withQueryParams({ path: replaceParams({ path, params }), queryParams }, options);
